import { useEffect, useState } from 'react';
import { ApiEndpoints, ApiQueryParams } from './apiEndpointUtils';
import useApi from './useApi';
import { ReportVersion } from 'types/ModelTypes';
import { getReportVersionHistoryError, ReportVersionHistoryError, sortReportVersionsNewestFirst } from 'pages/emission/reportVersionUtils';

type ReportVersionHistoryState =
    | { status: 'idle'; reportStatusId: null; versions: ReportVersion[]; error: null }
    | { status: 'loading'; reportStatusId: number; versions: ReportVersion[]; error: null }
    | { status: 'success'; reportStatusId: number; versions: ReportVersion[]; error: null }
    | { status: 'error'; reportStatusId: number; versions: ReportVersion[]; error: ReportVersionHistoryError };

export default () => {
    const { state, getApiData } = useApi();
    const [historyState, setHistoryState] = useState<ReportVersionHistoryState>({
        status: 'idle',
        reportStatusId: null,
        versions: [],
        error: null,
    });

    const getReportVersionHistory = (companyId: number, reportStatusId: number) => {
        setHistoryState({ status: 'loading', reportStatusId, versions: [], error: null });
        getApiData({
            endpoint: ApiEndpoints.getReportVersionHistory,
            queryParam: ApiQueryParams.getReportVersionHistory(companyId, reportStatusId),
        });
    };

    useEffect(() => {
        if (state.endpoint !== ApiEndpoints.getReportVersionHistory) return;

        if (state.status === 'success') {
            setHistoryState((current): ReportVersionHistoryState => {
                if (current.reportStatusId === null) return current;

                return {
                    status: 'success',
                    reportStatusId: current.reportStatusId,
                    versions: sortReportVersionsNewestFirst(state.result as ReportVersion[]),
                    error: null,
                };
            });
        }

        if (state.status === 'error') {
            setHistoryState((current): ReportVersionHistoryState => {
                if (current.reportStatusId === null) return current;

                return {
                    status: 'error',
                    reportStatusId: current.reportStatusId,
                    versions: [],
                    error: getReportVersionHistoryError(state.error),
                };
            });
        }
    }, [state]);

    return { getReportVersionHistory, historyState };
};
